import { NAVIGATION_STALE_THRESHOLD } from '../types';
import type { NavigationStateStore } from '../types';

export const pruneStaleNavigationState = (state: NavigationStateStore) => {
  const threshold = Date.now() - NAVIGATION_STALE_THRESHOLD;

  for (const key of Object.keys(state)) {
    if (state[key].timestamp < threshold) {
      delete state[key];
    }
  }
};
